import React from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { createUserTransactions } from 'src/axious/user-transactions'
import { handleAxiosError } from 'src/utils/errorHandling'
import { useGlobalStore } from 'src/zustand/providers/global-store-provider'

export const useSendingStars = () => {
  const [notEnoughStars, setNotEnoughStars] = React.useState<boolean>(false)

  const balanceStars = useGlobalStore((state) => state.user?.balance_stars)
  const reducingBalanceStars = useGlobalStore((state) => state.reducingBalanceStars)

  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const userId = searchParams.get('id')

  const sendingStarsToUser = async (value: string) => {
    if (balanceStars !== undefined) {
      if (balanceStars <= +value) {
        setNotEnoughStars(true)
        return
      }
    } else {
      return
    }

    try {
      const dataForSend = {
        amount_stars: +value,
        commission: 0,
        type: 'TRANSFER' as const,
        recipient: Number(userId),
      }

      await createUserTransactions(dataForSend)
      reducingBalanceStars(+value)
      navigate(`success?type=send&stars=${value}`, {
        replace: true,
      })
    } catch (err) {
      navigate('error')
      const errorMessage = handleAxiosError(err)
      console.log(errorMessage)
    }
  }

  return { notEnoughStars, sendingStarsToUser }
}
